const ERROR_MESSAGE = 'Error: innerArrayLength should be smaller than the length of target array';

const createTwoDimensionalArray = <T>(arr: T[] = [], type: 'detail' | string): T[][] => {
  const innerArrayLength = type === 'detail' ? 100 : 10;

  if (!arr || arr.length === 0) return [];

  return Array.from({ length: Math.ceil(arr.length / innerArrayLength) }, (_, i) =>
    arr.slice(i * innerArrayLength, (i + 1) * innerArrayLength),
  );
};

export { ERROR_MESSAGE, createTwoDimensionalArray };
